'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactScroll = require('react-scroll');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _containers = require('../../containers');
var _HomeFilters = require('./HomeFilters');var _HomeFilters2 = _interopRequireDefault(_HomeFilters);
var _ProjectFilters = require('./ProjectFilters');var _ProjectFilters2 = _interopRequireDefault(_ProjectFilters);

var _constants = require('../../constants');
var _formatSearchBoxData = require('../../utils/formatSearchBoxData');
var _multiselectsTitles = require('../../utils/multiselectsTitles');
var _sendSearchRequest = require('../../helpers/sendSearchRequest');var _sendSearchRequest2 = _interopRequireDefault(_sendSearchRequest);
var _scrollTo = require('../../utils/scrollTo');var _scrollTo2 = _interopRequireDefault(_scrollTo);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _checkAdvancedFiltersQuantity = require('../../helpers/checkAdvancedFiltersQuantity');var _checkAdvancedFiltersQuantity2 = _interopRequireDefault(_checkAdvancedFiltersQuantity);
var _formatPropertyTypes = require('../../utils/formatPropertyTypes');

var _PropertiesFilterContainer = require('../PropertiesFilterContainer/PropertiesFilterContainer.scss');var styles = _interopRequireWildcard(_PropertiesFilterContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
_reactScroll.scroller.scrollTo = _scrollTo2.default.bind(_reactScroll.scroller);var MobilePropertiesFilters = function (_Component) {_inherits(MobilePropertiesFilters, _Component);
  function MobilePropertiesFilters(props) {_classCallCheck(this, MobilePropertiesFilters);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.
















    getInputLocation = function (data) {
      _this.props.saveSearchedLocation(data);
      _this.setState({ selectedLocation: data });
      _this.props.handleChange('location', data);
    };_this.

    resetForm = function () {
      _this.clearInputLocation();
      _this.props.resetForm();
      _this.setState({
        resetAdvancedFilters: true });

    };_this.

    formatPriceParameters = function (field) {return {
        value: (0, _beautifyNumber2.default)(_this.props.fields[field]),
        onChange: function onChange(value) {return _this.props.handleChange(field, value);} };};_this.


    handleSubmit = function (evt) {
      evt.preventDefault();
      _this.handleMobileSearch();
    };_this.

    handleMobileSearch = function () {
      if (_this.state.selectedLocation && _this.state.selectedLocation[_this.props.routeData.locale]) {
        _this.props.saveSearchedLocation(_this.state.selectedLocation);
      }
      _this.props.startSubmitting();
      _this.props.routeData.firstLoad = false;
      _this.props.routeData.mobileSearch = true;

      (0, _sendSearchRequest2.default)(
      _this.props.fields,
      _this.props.alreadySearchedLocation, Object.assign({
        location: _this.props.filtersType }, _this.props.routeData));

      _this.setState({ activeSpinner: true });
      _this.props.saveFiltersQuantity();
      _this.props.hideMobileFilters();
    };_this.

    clearInputLocation = function () {
      _this.props.saveSearchedLocation(null);
      _this.setState({ selectedLocation: null });
      _this.props.handleChange('location', null);
    };_this.

    scrollTop = function () {
      _this.scrollTo('filters', { offset: -50 });
    };_this.

    scrollTo = function (element) {var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _reactScroll.scroller.scrollTo(element, Object.assign({
        duration: 500,
        smooth: true },
      options));

    };_this.







    formatPropertyTypes = function (location, option) {
      var section = (0, _get2.default)(_constants.sections, location + '.value');

      if (location === 'projects') {
        return (0, _formatPropertyTypes.unitePropertyTypesBySections)(_this.props.propertyTypes);
      }

      return (0, _get2.default)(_this.props, 'propertyTypes.' + section + '.' + option) || [];
    };_this.state = { selectedLocation: _this.props.routeData.locationSearch, activeSpinner: false, resetAdvancedFilters: false };return _this;}MobilePropertiesFilters.prototype.componentDidMount = function componentDidMount() {this.resetButton = document.querySelector('#' + this.props.resetButtonId);this.resetButton.addEventListener('click', this.resetForm);};MobilePropertiesFilters.prototype.componentWillUnmount = function componentWillUnmount() {this.resetButton.removeEventListener('click', this.resetForm);};MobilePropertiesFilters.prototype.handleOpenAdvancedFilters = function handleOpenAdvancedFilters() {// analytics
    (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.searchResults, _analyticsConstants.eventAction.open, _analyticsConstants.eventLabel.advancedFilter);this.props.openAdvancedFilters();};MobilePropertiesFilters.prototype.
  render = function render() {var _props =

    this.props,_props$fields = _props.fields,optionType = _props$fields.optionType,rooms = _props$fields.rooms,propertyTypesValues = _props$fields.propertyTypes,status = _props$fields.status,_props$routeData = _props.routeData,locale = _props$routeData.locale,location = _props$routeData.location,alreadySearchedLocation = _props.alreadySearchedLocation,formId = _props.formId;
    var currentLocation = location !== '404' ? location : '';
    var formattedPropTypes = this.formatPropertyTypes(currentLocation || _constants.sections.homes.location, optionType);
    var typesInput = (0, _formatSearchBoxData.formatTypes)(formattedPropTypes, this.props.rootTranslate, false, optionType);
    var typesTitle = (0, _multiselectsTitles.propertyTypesTitle)(propertyTypesValues, this.props.rootTranslate);
    var roomInput = (0, _formatSearchBoxData.formatRooms)((0, _constants.roomOptionsTitles)(this.props.translate('searchContainer')), this.props.translate);
    var roomTitle = (0, _multiselectsTitles.roomsTitle)(rooms || undefined, this.props.translate);
    var currentLocale = (0, _get2.default)(alreadySearchedLocation, '[' + locale + '].formatted');
    var defaultLocale = (0, _get2.default)(alreadySearchedLocation, 'en.formatted') || '';
    var locationValue = currentLocale || defaultLocale;

    var isHomeFilters = this.props.filtersType !== 'projects';
    var Filters = isHomeFilters ? _HomeFilters2.default : _ProjectFilters2.default;

    return (
      _react2.default.createElement(_reactScroll.Element, { name: 'filters', id: 'filters-form', className: 'form ' + styles.propertiesFilter },
        _react2.default.createElement(Filters, {
          translate: this.props.translate,
          locale: locale,
          status: status,
          optionType: optionType,
          typesInput: typesInput,
          typesTitle: typesTitle,
          roomInput: roomInput,
          roomTitle: roomTitle,
          locationValue: locationValue,
          handleChange: this.props.handleChange,
          scrollTo: this.scrollTo,
          formId: formId,
          isMobile: this.props.isMobile,
          propertyTypes: propertyTypesValues,
          rooms: rooms,
          handleSubmit: this.handleSubmit,
          getInputLocation: this.getInputLocation,
          clearInputLocation: this.clearInputLocation,
          formatPriceParameters: this.formatPriceParameters }),


        isHomeFilters &&
        _react2.default.createElement(_containers.AdvancedFilters, {
          scrollTop: this.scrollTop,
          getAdvancedFiltersValues: this.props.getAdvancedFiltersValues,
          isAdvancedFiltersOpen: this.props.isAdvancedFiltersOpen,
          resetAdvancedFilters: this.state.resetAdvancedFilters,
          resetButtonId: this.props.resetButtonId,
          handleChange: this.props.handleChange,
          optionType: optionType })));




  };return MobilePropertiesFilters;}(_react.Component);


MobilePropertiesFilters.propTypes = {
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  fields: _propTypes2.default.object.isRequired,
  routeData: _propTypes2.default.object.isRequired,
  resetForm: _propTypes2.default.func,
  startSubmitting: _propTypes2.default.func,
  saveSearchedLocation: _propTypes2.default.func,
  alreadySearchedLocation: _propTypes2.default.object,
  isAdvancedFiltersOpen: _propTypes2.default.bool,
  propertyTypes: _propTypes2.default.object,
  openAdvancedFilters: _propTypes2.default.func,
  formId: _propTypes2.default.string,
  handleChange: _propTypes2.default.func,
  getAdvancedFiltersValues: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  resetButtonId: _propTypes2.default.string,
  saveFiltersQuantity: _propTypes2.default.func,
  hideMobileFilters: _propTypes2.default.func,
  filtersType: _propTypes2.default.string };exports.default =


MobilePropertiesFilters;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MobilePropertiesFilters/MobilePropertiesFilters.js
// module id = 2952
// module chunks = 0